<template>
  <div class="contact-us">
    <div class="page-help content">
      <div class="wrap-form">
        <div class="wrapp-data">
          <div class="info">
            <h2>{{ $t("newHome.contactUs.title") }}</h2>
            <div class="txt">{{ $t(txt) }}</div>
          </div>
          <TestInput
            v-for="(dataF, index) in form"
            :key="index"
            v-model="dataF.value"
            :label="$t(dataF.label)"
            :type="dataF.type"
            :maxLength="dataF.maxLength ? dataF.maxLength : undefined"
            :error="dataF.error"
            @input="dataF.error = false"
            :class="{ 'wrapp-input-sm': index === 0 || index === 1 }"
            :style="{
              'margin-left': index === 1 ? 'auto' : ''
            }"
          />

          <div class="modal-checkbox">
            <label class="checkbox-wrapper">
              <input
                autocomplete="off"
                @change="rules_error = false"
                v-model="rules"
                type="checkbox"
              />
              <span class="checkmark"></span>
            </label>
            <router-link
              target="_blank"
              :to="{ name: 'Rules', params: { lang: $i18n.locale } }"
            >
              <div
                class="modal-checkbox-text"
                :class="{ 'error-txt': rules_error }"
              >
                {{ $t("newHome.contactUs.agreePolicy") }}
              </div>
            </router-link>
          </div>
          <button class="btn btn-msg" @click="handleSubmit">
            {{ $t("newHome.contactUs.sendMessage") }}
          </button>
        </div>
      </div>
      <div class="wrapp-img">
        <img src="@/assets/newImges/Container.png" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
import TestInput from "../shared/testInput.vue";
import { api } from "../../api";
export default {
  components: { TestInput },
  props: {
    txt: {
      type: String,
      required: false,
      default: "newHome.contactUs.headText"
    },
    page: {
      type: String,
      required: false,
      default: "home"
    }
  },
  data() {
    return {
      form: [
        {
          label: "newHome.contactUs.name",
          value: "",
          name: "name",
          type: "text",
          required: true,
          error: false
        },
        {
          label: "newHome.contactUs.lastName",
          value: "",
          name: "last_name",
          type: "text",
          required: true,
          error: false
        },
        {
          label: "newHome.contactUs.email",
          value: "",
          name: "email",
          type: "text",
          required: true,
          error: false
        },
        {
          label: "newHome.contactUs.message",
          value: "",
          name: "message",
          type: "textarea",
          maxLength: 255,
          required: true,
          error: false
        }
      ],
      rules: false,
      rules_error: false
    };
  },
  methods: {
    isValidEmail(email) {
      // Jednostavna regularna ekspresija za e-mail validaciju
      // const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const re = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
      return re.test(email);
    },
    handleSubmit() {
      let valid = true;
      this.rules_error = false;

      this.form.forEach((field, index) => {
        const value = field.value.trim();

        if (field.required && !value) {
          field.error = true;
          valid = false;
        } else if (field.name === "email" && !this.isValidEmail(value)) {
          field.error = true;
          valid = false;
        } else if (field.name === "message" && field.value.length > 255) {
          field.error = true;
          valid = false;
        } else {
          field.error = false;
        }
      });

      if (!this.rules) {
        valid = false;
        this.rules_error = true;
      }

      if (valid) {
        this.sendData();
      }
    },
    async sendData() {
      console.log("send data");
      const params = { franchise: this.page === "franchise" };
      this.form.forEach(field => {
        params[field.name] = field.value;
      });

      try {
        const res = await api.contactUs(params);
        console.log(res.data.res);
        if (res.data.res) {
          this.$toast.success(this.$t("newHome.contactUs.successMsg"), {
            duration: 8000
          });
        }
        this.resetForm();
      } catch (error) {
        console.log(error);
      }
    },
    resetForm() {
      this.form.forEach(field => {
        field.value = "";
      });
      this.rules = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.contact-us {
  width: 100%;
  padding-top: 173px;
  padding-bottom: 173px;
  background-color: $gray-blue-100;
  font-family: Outfit;
  .content {
    display: flex;

    .wrap-form {
      box-sizing: border-box;
      padding: 120px 42px 0;
      max-width: 803px;
      background-color: $gray-blue-400;
      margin-right: 33px;
      border-radius: 12px;
      text-align: left;
      h2 {
        font-weight: 600;
        font-style: SemiBold;
        font-size: 36px;
        line-height: 100%;
        letter-spacing: 0%;
        color: $blue-1000;
        margin: 0 0 51px 0;
      }
      .txt {
        font-weight: 500;
        font-style: Medium;
        font-size: 20px;
        line-height: 30px;
        letter-spacing: 0%;
        color: $blue-400;
        margin: 0 0 75px 0;
      }
      .wrapp-data {
        display: flex;
        flex-wrap: wrap;
        // justify-content: space-between;
        align-content: flex-start;
        height: 100%;

        .input-wrapper {
          padding-bottom: 48px;
        }
        .wrapp-input-sm {
          width: 48%;
        }
      }
    }
    .wrapp-img {
      max-width: 504px;
    }
  }
}
.modal-checkbox {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  margin-bottom: 30px;
  input {
    border: 1px solid $gray-blue-700;
    cursor: pointer;
  }

  a {
    text-decoration: none;
    margin-left: 10px;
  }

  .modal-checkbox-text {
    font-weight: 400;
    font-style: Regular;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0%;
    color: $blue-400;
  }
}

.btn-msg {
  margin-top: 70px;
  box-sizing: border-box;
  background-color: $blue-600;
  width: 100%;
  font-weight: 400;
  font-style: Regular;
  font-size: 20px;
  line-height: 28px;
  letter-spacing: 0%;
  border-radius: 10px;
}
.error-txt {
  color: $red-600 !important;
}
@media only screen and (max-width: 960px) {
  .contact-us {
    padding-top: 73px;
    padding-bottom: 73px;
    .content {
      display: flex;
      flex-direction: column;

      .wrap-form {
        box-sizing: border-box;
        padding: 80px 42px 0;
        max-width: 100%;
        background-color: $gray-blue-400;
        margin-right: 0px;
        padding-bottom: 70px;

        h2 {
          font-weight: 600;
          font-style: SemiBold;
          font-size: 36px;
          line-height: 100%;
          letter-spacing: 0%;
          color: $blue-1000;
          margin: 0 0 51px 0;
        }
        .txt {
          font-weight: 500;
          font-style: Medium;
          font-size: 20px;
          line-height: 30px;
          letter-spacing: 0%;
          color: $blue-400;
          margin: 0 0 75px 0;
        }
        .wrapp-data {
          display: flex;
          flex-wrap: wrap;
          // justify-content: space-between;
          align-content: flex-start;
          height: 100%;
          .input-wrapper {
            padding-bottom: 28px;
          }
          .wrapp-input-sm {
            width: 48%;
          }
        }
      }
      .wrapp-img {
        max-width: 100%;
        overflow: hidden;
        display: flex;
        justify-content: center;
        border-radius: 12px;
        img {
          object-fit: cover;
          height: 500px;
          width: 100%;
        }
      }
    }
  }
  .btn-msg {
    margin-top: 15px;
  }
}
@media only screen and (max-width: 768px) {
  .contact-us {
    padding-top: 53px;
    padding-bottom: 53px;
    .content {
      .wrap-form {
        box-sizing: border-box;
        padding: 50px 42px 0;
        padding-bottom: 40px;

        h2 {
          font-size: 32px;
          line-height: 100%;
          margin: 0 0 31px 0;
        }
        .txt {
          font-size: 16px;
          line-height: 25px;

          margin: 0 0 35px 0;
        }
        .wrapp-data {
          display: flex;
          flex-wrap: wrap;
          // justify-content: space-between;
          align-content: flex-start;
          height: 100%;

          .input-wrapper {
            padding-bottom: 18px;
          }
          .wrapp-input-sm {
            width: 100%;
          }
        }
      }
      .wrapp-img {
        max-width: 100%;
        overflow: hidden;
        display: flex;
        justify-content: center;
        border-radius: 12px;
        img {
          object-fit: cover;
          height: 500px;
          width: 100%;
        }
      }
    }
  }
  .btn-msg {
    margin-top: 0px;
  }
}
</style>
